import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=53ecce19&scoped=true"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js"
import style0 from "./AccountChangePassword.vue?vue&type=style&index=0&id=53ecce19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ecce19",
  null
  
)

/* custom blocks */
import block0 from "./AccountChangePassword.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports